<button
  (click)="openMigrationPopup()"
  id="alert-border-4"
  class="w-full flex items-center p-4 bg-opacity-10 relative cursor-pointer {{
    currentGroup.type === GroupType.Hcp
      ? 'text-kimbo-blue border-t-4 border-kimbo-blue bg-kimbo-blue flex-col md:flex-row gap-4 justify-center'
      : 'text-kimbo-ruby border-t-4 border-kimbo-ruby bg-kimbo-ruby'
  }}"
  role="alert">
  <div
    class="w-fit mx-auto ms-3 text-sm font-medium flex justify-center items-center gap-4">
    <div [inlineSVG]="'assets/svg/info.svg'"></div>
    <span>{{
      (currentGroup.type === GroupType.Hcp
        ? 'hcp-home.migration-msg'
        : 'kimbo-layout.migration-notice-title'
      ) | translate
    }}</span>
  </div>
  <div class="flex items-center justify-center gap-2">
    <mat-icon *ngIf="currentGroup.type !== GroupType.Hcp" class="w-6"
      >open_in_new</mat-icon
    >
    <button
      *ngIf="currentGroup.type === GroupType.Hcp"
      mat-raised-button
      color="primary">
      {{ 'hcp-home.goto-new-app' | translate }}
    </button>
  </div>
</button>
